<template>
  <AssetModbusParamSet />
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import AssetModbusParamSet from '@/components/content/AssetModbusParamSet.vue'

export default defineComponent({
  name: 'AssetModbusParamSetView',
  components: { AssetModbusParamSet },

  setup(props, context) {
    const i18n = useI18n()

    context.emit('pageName', i18n.t('aside.menu.pages.assetModbusParamSet'))

    watch(() => i18n.locale.value, () => {
      context.emit('pageName', i18n.t('aside.menu.pages.assetModbusParamSet'))
    })
  }
})
</script>
